/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Order_Discount_LabelInputs */

const vi_order_discount_label = /** @type {(inputs: Order_Discount_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CK đơn (${i?.percent}%)`)
};

/**

* @param {Order_Discount_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_discount_label = /** @type {((inputs: Order_Discount_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Discount_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_discount_label(inputs)
});